<template>
  <span>
    <span :class="{ noBorder, noMargin }" class="currency-icon-wrap">
      <img
        :src="icon"
        :style="{ width: size, height: size }"
        class="currency-icon"
      />
    </span>
    <template v-if="!hideLabel">
      {{ label || symbol }}
    </template>
  </span>
</template>

<script>
export default {
  name: 'CurrencyIcon',
  props: {
    symbol: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '3rem',
    },
  },
  computed: {
    icon() {
      return this.$store.getters['common/getIcon'](this.symbol)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/base';

.currency-icon {
  display: inline-block;
  vertical-align: middle;
  font-size: 2rem;

  &-wrap {
    display: inline-block;

    &:not(.noBorder) {
      border-radius: 100%;
      padding: 3px;
      border: 2px solid $blue;
    }
    &:not(.noMargin) {
      margin-right: 0.5rem;
    }

    &--large:not(.noBorder) {
      padding: 17px;
      border: 4px solid $blue;
    }

    img {
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
